export const QUERY_PLACEHOLDER_REGEX = /:([a-zA-Z0-9_]+)/g;
